import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { debounce } from 'lodash';
import { CollaboratorsService } from 'src/app/api/collaborator/collaborators.service';
import * as _ from 'underscore';
declare var $: any;


@Component({
  selector: 'component-search-collaborators',
  templateUrl: './search-collaborators.component.html',
  styleUrls: ['./search-collaborators.component.css']
})
export class SearchCollaboratorsComponent implements OnInit{
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedCollaboratorsEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'fullname_str';
  isTypedSearch = false;
  classSearch:any;

  constructor(private collaboratorsService: CollaboratorsService) {
  }

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.collaboratorsService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
          this.data.map((item:any) => item.fullname_str = `${item.fullname} ${item.document}`);
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearchClient(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);
    
    this.selectedCollaboratorsEvent.emit(item);
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }

}

